import { Component, Input, OnInit } from '@angular/core';

import { EnvironmentService } from '@patient-ui/shared-ui/utils';

@Component({
  selector: 'ui-legal-disclaimer',
  templateUrl: './legal-disclaimer.component.html',
  styleUrls: ['./legal-disclaimer.component.scss'],
})
export class LegalDisclaimerComponent implements OnInit {
  @Input() addClass = 'text-dark';
  @Input() linkText = 'Link Account';
  @Input() termsLinkText = 'Online Services User Agreement';
  @Input() privacyUrl = 'https://www.labcorp.com/hipaa-privacy';

  // Dynamic URLs based on environment
  public effectiveTermsUrl = '';
  public effectiveTermsLinkText = '';

  constructor(private environmentService: EnvironmentService) {}

  ngOnInit() {
    this.setEffectiveTermsProperties();
  }

  private setEffectiveTermsProperties() {
    // Use environment-specific Online Services User Agreement
    this.effectiveTermsUrl = this.environmentService.userAgreementUrl;
    this.effectiveTermsLinkText = this.termsLinkText;
  }
}
